export default __webpack_public_path__ + "static/media/handover.template.9ad37a44.hbs";